import { get } from 'lodash'
import { FAKE_IMAGES, WOODEN_CRATE } from 'utils/constants'

import { orderCertificationAdd } from './actions'

export const mapOrderInit = (order = {}, vendor, vendorData, dispatch) => {
  const {
    state,
    orderManagementPickUpLocation,
    netToVendor,
    country,
    expected_shipping_at
  } = order
  const orderItems = order.line_items
  const { shippingOption, shippingMethod } = orderItems[0] || {}
  const vendorOrderManagementPickUpLocation = orderManagementPickUpLocation

  return {
    country,
    products: orderItems.map((pbs) => {
      const {
        customization,
        customization_pdf,
        variant_description,
        price,
        productData = {},
        quantity,
        expected_shipping_at,
        isCategoryLighting
      } = pbs
      const { displayTitle, sku, category, material } = productData || {}
      const type = category.name.en
      const mainPhoto = productData.mainPhoto
      const purchaseOrderItem = pbs.purchaseOrderItem
      // Unique row identity: multiple line items can share the same SKU, so the
      // SKU alone is not unique. Fall back to the SKU for legacy line items
      // without a purchaseOrderItem.
      const rowId = purchaseOrderItem ? `${sku}__${purchaseOrderItem}` : sku
      // The management document is resolved authoritatively by the backend per
      // line item (exact purchaseOrderItem match with legacy SKU fallback).
      const productOrderData = pbs.orderManagement || {}
      dispatch(
        orderCertificationAdd({
          productId: rowId,
          url: get(productOrderData, 'cardbCertification', '')
        })
      )

      const woodenCrateValue =
        productData?.customProperties.find(
          (prop) => prop.label.en === WOODEN_CRATE.en
        )?.value || 0

      return {
        comments: get(productOrderData, 'comments', ''),
        customization: customization || '',
        customizationFile: customization_pdf,
        variantDescription: variant_description,
        imageAlt: displayTitle.en,
        imageSrc: mainPhoto || FAKE_IMAGES.ORDER_PRODUCT,
        material: material.name.en,
        price,
        productName: displayTitle.en,
        quantity,
        parcels: get(productOrderData, 'parcels', []),
        certificationFile: get(productOrderData, 'cardbCertification', ''),
        shippingDate: expected_shipping_at,
        imagesReady: get(productOrderData, 'readyPhoto', []),
        imagesPacked: get(productOrderData, 'packagePhoto', []),
        orderManagementId: get(productOrderData, '_id', ''),
        shipAddress: {
          // only for legacy behaviour
          country: {
            id: country.isocode,
            code: country.isocode,
            name: country.nameEN
          }
        },
        type,
        isCategoryLighting,
        slug: productData.slug.en,
        isDiscontinued: productData.discontinuedOn ? true : false,
        vendorCode: get(pbs, 'productData.manufacturerNumber'),
        woodenCrateValue,
        woodenCrateNeededVendor: woodenCrateValue > 0, //vendorData.woodenCrateNeeded, // TODO rivedere logica
        _id: rowId,
        sku,
        purchaseOrderItem,
        supplierId: get(pbs, 'productData.supplierId')
      }
    }),
    netToVendor: netToVendor?.toLocaleString('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }),
    shipBy: expected_shipping_at,
    status: state,
    orderPickup: vendorOrderManagementPickUpLocation && {
      ...vendorOrderManagementPickUpLocation,
      address2: vendorOrderManagementPickUpLocation.address2 || ''
    },
    purchaseOrder: get(order, 'PurchaseOrder', ''),
    shippingOption,
    shippingMethod
  }
}
